import React from 'react';
import { FileTextIcon, ClockIcon, BarChartIcon, RefreshCwIcon, ShoppingCartIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
export const WhatsIncluded = () => {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-teal-50" data-id="element-456">
      <div className="max-w-5xl mx-auto" data-id="element-457">
        <div className="text-center mb-10" data-id="element-458">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-459">
            ¿Qué incluye?
          </h2>
          <p className="text-xl text-gray-700" data-id="element-460">
            Todo lo que necesitas para transformar tu alimentación
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-461">
          <div className="p-6" data-id="element-462">
            <ul className="space-y-5" data-id="element-463">
              <li className="flex gap-4" data-id="element-464">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-465">
                  <FileTextIcon className="h-5 w-5 text-teal-700" data-id="element-466" />
                </div>
                <div data-id="element-467">
                  <p className="font-medium text-gray-900" data-id="element-468">
                    +60 recetas listas en &lt;15 min
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-469">
                    Desayunos, almuerzos, cenas y snacks
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-470">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-471">
                  <BarChartIcon className="h-5 w-5 text-teal-700" data-id="element-472" />
                </div>
                <div data-id="element-473">
                  <p className="font-medium text-gray-900" data-id="element-474">
                    Porciones sugeridas y macros orientativos
                  </p>
                  <ul className="text-gray-600 text-sm list-disc pl-5 mt-1" data-id="element-475">
                    <li data-id="element-476">Calorías totales por porción</li>
                    <li data-id="element-477">Proteínas (g)</li>
                    <li data-id="element-478">Carbohidratos (g)</li>
                    <li data-id="element-479">Grasas (g)</li>
                  </ul>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-480">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-481">
                  <FileTextIcon className="h-5 w-5 text-teal-700" data-id="element-482" />
                </div>
                <div data-id="element-483">
                  <p className="font-medium text-gray-900" data-id="element-484">
                    Alternativas y variantes
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-485">
                    Opciones vegetarianas y sin gluten donde corresponde
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-486">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-487">
                  <RefreshCwIcon className="h-5 w-5 text-teal-700" data-id="element-488" />
                </div>
                <div data-id="element-489">
                  <p className="font-medium text-gray-900" data-id="element-490">
                    Actualizaciones gratis
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-491">
                    Cada nueva tanda de recetas se agrega sin costo
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-492">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-493">
                  <ShoppingCartIcon className="h-5 w-5 text-teal-700" data-id="element-494" />
                </div>
                <div data-id="element-495">
                  <p className="font-medium text-gray-900" data-id="element-496">
                    Lista de compras y guía de batch cooking
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-497">
                    Organiza tu fin de semana para tener comida toda la semana
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-498">
          <a href="https://organicecomm.com/cart/51818275930293:1" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300" onClick={trackPurchaseClick} data-id="element-499">
            Quiero mi recetario por $17 USD
          </a>
        </div>
      </div>
    </section>;
};